import React from "react";
import moment from "moment";
// import { procedure as mockProcedure } from "../../__mocks__";
// import { parseProcedure } from "./parser";
import { Box, Grid, InputLabel, List, Typography } from "@common-ui/ui";
// import { FrameRenderer } from "./Renderer";
import {
  // getProcedure,
  getProcedures,
  getServiceOptions,
  getServiceTypesForOrg,
  // getWorkItem,
} from "../../services";
import { Section } from "./components/Section";
import { EquipmentList } from "../Equipment";
import CustomizedProgressBars from "./Progress";
// import { float } from "html2canvas/dist/types/css/property-descriptors/float";
// import {FrameRenderer} from "./Renderer"
// import { getProcedure } from "../../services";

class Procedure extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      procedure: null,
      isLoading: false,
      expanded: false,
      config: {},
      summaryResult: [],
    };
  }

  componentDidMount() {
    // const { orgID, rowProp } = this.props;
    // // const procedure = parseProcedure(mockProcedure);
    // console.log("this.props", this.props);
    // this.setState({ config });
    // configure({})
    // this.fetchData();
  }

  handleRemoveSection = (sectionId) => {};

  handleChangeAccordion = (panel) => (event, isExpanded) => {
    this.setState({ expanded: isExpanded ? panel : false });
  };

  fetchData = async () => {
    const {
      // rowProp,
      orgID,
    } = this.props;
    let serviceTypes, serviceOptions;
    if (orgID) {
      serviceTypes = await getServiceTypesForOrg(orgID);
    }
    if (serviceTypes) {
      serviceOptions = await getServiceOptions(
        serviceTypes[0].system_id,
        orgID
      );
    }
    const procedures = await getProcedures(
      // rowProp.service_option_procedure,
      // orgID,
      serviceTypes[0].system_id,
      serviceOptions[0].system_id
    );
    // console.log("procedures", procedures);
    let procedure = null;
    if (procedures?.data?.length) {
      procedure = procedures?.data.find((item) => item.status === "COMPLETED");
    }
    // console.log("procedure", procedures, procedure);

    this.setState({ procedure, isLoading: false });
  };

  displaySection = (items = [], status) => {
    return Array.from(items).map((section, index) => {
      return (
        <Section
          rowProp={this.props.rowProp}
          orgID={this.props.orgID}
          key={section.id}
          section={section}
          procedureStatus={status}
          sectionId={section.id}
          step={index + 1}
          expanded={this.state.expanded}
          handleChangeAccordion={this.handleChangeAccordion}
        />
      );
    });
    // section level one
    // return items.map((item, sectionIndex) => {
    //   return (
    //     <Box>
    //       <InputLabel sx={{ display: "flex", alignItems: "center" }}>
    //         <Typography fontWeight="700">{item.title}</Typography>
    //       </InputLabel>
    //       {this.displaySubSection(item.items, sectionIndex)}
    //     </Box>
    //   );
    // });
  };

  displaySubSection = (items = [], sectionIndex) => {
    return items.map((item, subSectionIndex) => {
      return this.procedureFSM(item, sectionIndex, subSectionIndex);
    });
  };

  procedureFSM = (item, sectionIndex, itemIndex) => {
    // console.log("subSection", item);
    return "Coming Soon!";
    // if (!this.state.procedure) return "";
    // const steps = [];
    // const section = this.state.procedure.items.find(
    //   (v, i) => i === sectionIndex
    // );

    // // console.log("section", section);
    // Array.from(section.items).forEach((element, newIndex) => {
    //   const elementStep = `${steps.length + 1}`;
    //   if (!element.test_points || element.subName) {
    //     steps.push({ id: element.id, step: elementStep, nextSteps: [] });
    //     if (element.test_points) {
    //       Array.from(element.test_points).forEach((item, i) => {
    //         steps
    //           .find((element) => element.id === subSection.id)
    //           ?.nextSteps.push({
    //             id: item.id,
    //             step: `${elementStep}.${i + 1}`,
    //             nextSteps: [],
    //           });
    //       });
    //     } else {
    //       steps
    //         .find((element) => element.id === subSection.id)
    //         ?.nextSteps.push({
    //           id: element.id,
    //           step: `${elementStep}.1`,
    //           nextSteps: [],
    //         });
    //     }
    //   } else {
    //     Array.from(element.test_points).forEach((item, i) => {
    //       steps.push({
    //         id: item.id,
    //         step: `${steps.length + 1}`,
    //         nextSteps: [],
    //       });
    //     });
    //   }
    // });
    // if (subSection.subType) {
    //   return "SubType";
    // }
    // switch (subSection.type) {
    //   case "CUSTOM":
    //     return (
    //       <CustomView
    //         subSection={subSection}
    //         sectionIndex={sectionIndex}
    //         subSectionIndex={subSectionIndex}
    //         steps={steps}
    //       />
    //     );
    //   case "INSTRUCTION":
    //     return (
    //       <div>
    //         <span style={{ display: "flex", alignItems: "center" }}>
    //           <Typography sx={{ mr: 1 }}>
    //             {`${sectionIndex + 1}.${
    //               steps.find((element) => element.id === subSection.id).step
    //             }`}
    //           </Typography>
    //         </span>
    //         <Grid>
    //           <Grid item md={6} xs={12}>
    //             {subSection.infoPanel === "Information" ? (
    //               <Alert sx={{ my: 2 }} severity="info">
    //                 Information
    //               </Alert>
    //             ) : subSection.infoPanel === "Warning" ? (
    //               <Alert sx={{ my: 2 }} severity="warning">
    //                 Warning
    //               </Alert>
    //             ) : subSection.infoPanel === "Danger" ? (
    //               <Alert sx={{ my: 2 }} severity="error">
    //                 Danger / Error
    //               </Alert>
    //             ) : (
    //               <Box sx={{ my: 1 }}></Box>
    //             )}
    //             {/* <div>{<InfoPanel key={subSection.infoPanel} />}</div> */}
    //           </Grid>
    //           <Grid item md={12} xs={12}>
    //             {subSection.content}
    //           </Grid>
    //         </Grid>
    //         {/* <div>Coming Soon!</div>  */}
    //         <Divider sx={{ my: 2 }} />
    //       </div>
    //     );
    //   case "PASS/FAIL":
    //     return (
    //       <PassFail
    //         subSection={subSection}
    //         sectionIndex={sectionIndex}
    //         subSectionIndex={subSectionIndex}
    //         steps={steps}
    //       />
    //     );
    //   case "YES/NO":
    //     return (
    //       <YesNo
    //         subSection={subSection}
    //         sectionIndex={sectionIndex}
    //         subSectionIndex={subSectionIndex}
    //         steps={steps}
    //       />
    //     );
    //   case "SUB-SECTION":
    //     return "Coming Soon!";
    //   case "TASK ITEM":
    //     return "Coming Soon!";
    //   default:
    //     return "Coming Soon!";
    // }
  };

  render() {
    const { isLoading } = this.state;
    let procedure = this.props?.procedureRuntimeState?.procedure;
    const status = this.props?.procedureRuntimeState?.status;
    return isLoading ? (
      "Loading..."
    ) : (
      <Box>
        {!this.props.report ? (
          <Grid container spacing={2} sx={{ px: 2 }}>
            {/* <Grid item md={3}>
              <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                <Typography fontWeight="700">Title</Typography>
              </InputLabel>
              <Typography variant="body1">{procedure?.title}</Typography>
            </Grid> */}
            <Grid item md={3}>
              <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                <Typography fontWeight="700">Title</Typography>
              </InputLabel>
              <Typography variant="body1">{procedure?.title}</Typography>
            </Grid>
            <Grid item md={3}>
              <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                <Typography fontWeight="700">Revision</Typography>
              </InputLabel>
              <Typography variant="body1">
                {String(procedure?.revision).trim() !== ""
                  ? procedure?.revision
                  : "---"}
              </Typography>
            </Grid>
            <Grid item md={3}>
              <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                <Typography fontWeight="700">Last Update</Typography>
              </InputLabel>
              <Typography variant="body1">
                {moment(procedure?.update_date).format("YYYY-MM-DD LT")}
              </Typography>
            </Grid>
            <Grid item md={3}>
              <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                <Typography fontWeight="700">Create Date</Typography>
              </InputLabel>
              <Typography variant="body1">
                {moment(procedure?.create_date).format("YYYY-MM-DD LT")}
              </Typography>
            </Grid>
            <Grid item md={3}>
              <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                <Typography fontWeight="700">Description</Typography>
              </InputLabel>
              <Typography variant="body1">
                {String(procedure?.description).trim() !== ""
                  ? procedure?.description
                  : "---"}
              </Typography>
            </Grid>
            <Grid item md={3}></Grid>
            <Grid item md={3}>
              <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                <Typography fontWeight="700">Steps</Typography>
              </InputLabel>
              {status?.procedure?.num_completed ? (
                <CustomizedProgressBars
                  value={
                    (status?.procedure?.num_completed /
                      status?.procedure?.num_steps) *
                    100
                  }
                />
              ) : (
                ""
              )}

              <Typography variant="body1">
                {status?.procedure?.num_completed
                  ? `${status?.procedure?.num_completed}/${status?.procedure?.num_steps}`
                  : "---"}
              </Typography>
            </Grid>
            {/* <Grid item md={9}>
              {this.props?.summaryReason}
            </Grid> */}
            <Grid item md={3}>
              {this.props?.assignee}
            </Grid>
            <Grid item md={9}>
              {this.props?.notes}
            </Grid>
            <Grid item md={3}>
              <InputLabel>
                <Typography fontWeight="700" variant="subtitle1">
                  Equipment
                </Typography>
              </InputLabel>
              <EquipmentList
                workEvent={this.props.rowProp?.work_event}
                orgID={this.props.orgID}
                workItem={this.props.rowProp}
                mode={this.props.mode}
                report={this.props.report}
                rowProp={this.props.rowProp}
              />
            </Grid>
          </Grid>
        ) : (
          ""
        )}
        <Box>
          <List>
            {procedure?.items
              ? Array.from(procedure?.items).map((newSection, index) => {
                  return (
                    <Section
                      rowProp={this.props.rowProp}
                      orgID={this.props.orgID}
                      key={newSection.id}
                      section={newSection}
                      procedureStatus={status}
                      sectionId={newSection.id}
                      step={index + 1}
                      expanded={this.state.expanded}
                      handleChangeAccordion={this.handleChangeAccordion}
                      mode={this.props.mode}
                      summaryResult={this.state.summaryResult}
                    />
                  );
                })
              : "Not found"}
          </List>
        </Box>
      </Box>
    );
  }
}
export default Procedure;
